import { render, staticRenderFns } from "./ReAllocation.vue?vue&type=template&id=172057ab&scoped=true&lang=pug&"
import script from "./ReAllocation.vue?vue&type=script&lang=ts&"
export * from "./ReAllocation.vue?vue&type=script&lang=ts&"
import style0 from "./ReAllocation.vue?vue&type=style&index=0&id=172057ab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172057ab",
  null
  
)

export default component.exports